export const isNumber = (input) => RegExp(/\d/, "gi").test(input)
